import React from 'react'
import StyledBreadcrumbs from 'Components/StyledBreadcrumbs'
import { PATHS } from 'Config/Routing/paths'

import CampaignsIcon from 'Assets/Images/icons/campaigns'

const BreadcrumbsAIRoster = ({ campaign, city, cityPlan }) => (
  <div>
    <StyledBreadcrumbs
      icon={<CampaignsIcon style={{ width: 16 }} />}
      breadcrumbs={[
        {
          label: 'Campaigns',
          link: `${PATHS.main.dashboard}${
            PATHS.dashboard.campaigns
          }?Status=Active`,
        },
        {
          label: campaign.name,
          link: `${PATHS.main.dashboard}${PATHS.dashboard.campaigns}/${
            campaign.id
          }/city-plans`,
        },

        {
          label: `City Plan (${city.name})`,
          link: `${PATHS.main.dashboard}${PATHS.dashboard.campaigns}/${
            campaign.id
          }/city-plans/${cityPlan.id}`,
        },

        { label: 'AI Roster' },
      ]}
    />
  </div>
)

export default BreadcrumbsAIRoster
